import { forwardRef } from "react";
import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledPassThroughDiv = styled(Box, {
  shouldForwardProp: prop => !['position', 'pointer'].includes(prop)
})`
  position: ${({ position }) => position ? position : 'fixed'};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  pointer-events: ${({ pointer }) => pointer ? pointer : 'none'};
  z-index: 1;
  // overflow: hidden;
`;

const PassThroughDiv = forwardRef(({ children, ...rest }, ref) => {
  return <StyledPassThroughDiv ref={ref} {...rest}>{children}</StyledPassThroughDiv>
});

export default PassThroughDiv;